<template>
    <div style="width: 100%; height: 100%;">
        <NaverMap />
    </div>
</template>

<script>
import { $WC } from '@/conf/common.const.js';
import NaverMap from "@/components/NaverMap.vue";
import { NaverMapGeoJsonDrawing } from "@/lib/grip.naver.map.geojson.v2.js";

export default {
    name: 'DrawRegionNaverMap',
    props: {
        geojsonUrl: {
            type: String,
            required: false,
            default: $WC.cp + 'geojson/adarea/' + $WC.geojsonPath + '/emd.json',
        },
        areaClickEnable: {
            type: Boolean,
            required: false,
            default: true,
        }
    },
    data: function() {
        return {
            map: {},
            geoJsonDrawing: {},
            selectedAddongCd: ""
        };
    },
    created: function() {
        // 지도 로딩 완료 이벤트
        this.$eventBus.$once('NaverMap::map-loaded', map => {
            this.map = map;
            this.geoJsonDrawing = new NaverMapGeoJsonDrawing(map);
            this.drawGeoJson();
        });
    },
    methods: {
        drawGeoJson() {
            this.geoJsonDrawing.setGeoJsonUrl(this.geojsonUrl).setkeyPropNm('adm_code');
            if(this.areaClickEnable) {
                this.geoJsonDrawing.setClickHandle((geoJsonDrawing, prop, event) => {
                    let admCode = prop.adm_code;
                    this.geoJsonDrawing.setOptionAll('strokeColor', '#ffffff');
                    this.geoJsonDrawing.setOptionAll('strokeWeight', 2);
                    this.geoJsonDrawing.setZIndexAll(0);

                    if(this.selectedAddongCd !== admCode) {
                        this.geoJsonDrawing.setOption(admCode, 'strokeColor', '#000000');
                        this.geoJsonDrawing.setOption(admCode, 'strokeWeight', 4);
                        this.geoJsonDrawing.setZIndex(admCode, 100);

                        this.selectedAddongCd = admCode;
                        this.$eventBus.$emit("DrawRegionNaverMap::change-selected-area", prop);
                    } else {
                        this.selectedAddongCd = "";
                        this.$eventBus.$emit("DrawRegionNaverMap::change-selected-area", null);
                    }
                })
            }
            this.geoJsonDrawing.setCompletedHandle(geoJsonDrawing => {
                    this.$eventBus.$emit("DrawRegionNaverMap::completed-draw-region", geoJsonDrawing);
            }).drawGeoJson();
        }
    },
    components: {
        NaverMap,
    }
}
</script>
